/* Black Friday : encart fiche produit (compte a rebours, economie, cadeau au panier). */
(function () {
  'use strict';
  var root = document.querySelector('[data-bf-pe]');
  if (!root) return;

  var euro = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 });
  function money(cents) { return euro.format(cents / 100); }

  /* ---- Variantes : id -> {p: prix, c: prix barre} (en centimes) ---- */
  var table = {};
  (root.getAttribute('data-variants') || '').split(';').forEach(function (s) {
    var a = s.split(':');
    if (a.length === 3) table[a[0]] = { p: parseInt(a[1], 10), c: parseInt(a[2], 10) };
  });

  var ticket = root.querySelector('[data-bf-ticket]');
  var eco = root.querySelector('[data-bf-eco]');

  function maj(id, fallback) {
    var v = table[id] || fallback;
    if (!v) return;
    var d = v.c - v.p;
    if (ticket && eco) {
      if (d > 0) { eco.textContent = money(d); ticket.hidden = false; } else { ticket.hidden = true; }
    }
  }

  function variantDepuisUrl() {
    var m = /[?&]variant=(\d+)/.exec(location.search);
    return m ? m[1] : null;
  }

  maj(variantDepuisUrl() || root.getAttribute('data-variant'));

  /* Evenement Motion : 'variant:change' (document) avec detail.variant */
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    maj(String(v.id), { p: v.price, c: v.compare_at_price || 0 });
  });

  /* ---- Compte a rebours ---- */
  var fin = new Date(root.getAttribute('data-fin')).getTime();
  var cd = root.querySelector('[data-bf-cd]');
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tic() {
    var reste = Math.max(0, fin - Date.now());
    if (!cd || isNaN(fin)) return;
    if (reste === 0) { root.querySelector('.bf-pe__fin').hidden = true; return; }
    var s = Math.floor(reste / 1000);
    cd.querySelector('[data-u="j"]').textContent = Math.floor(s / 86400);
    cd.querySelector('[data-u="h"]').textContent = pad(Math.floor(s % 86400 / 3600));
    cd.querySelector('[data-u="m"]').textContent = pad(Math.floor(s % 3600 / 60));
    cd.querySelector('[data-u="s"]').textContent = pad(s % 60);
  }
  tic();
  setInterval(tic, 1000);

  /* ---- Cadeau au choix (Venus E 3.0 et MAX) ---- */
  if (!root.getAttribute('data-cadeau')) return;

  var format = root.querySelector('[data-bf-format]');
  function choix() {
    var r = root.querySelector('input[name="bf-cadeau"]:checked');
    return r ? r.value : 'pb';
  }
  root.querySelectorAll('input[name="bf-cadeau"]').forEach(function (r) {
    r.addEventListener('change', function () { if (format) format.hidden = choix() !== 'piles'; });
  });

  function idCadeau() {
    if (!root.querySelector('input[name="bf-cadeau"]')) return '';
    if (choix() === 'pb') return root.getAttribute('data-gift-pb');
    var f = root.querySelector('input[name="bf-piles-format"]:checked');
    return root.getAttribute(f && f.value === 'aaa' ? 'data-gift-aaa' : 'data-gift-aa');
  }

  /* Un seul cadeau de chaque sorte par panier : « 1 » = cadeau au choix, « ct » = compteur CT002 offert. */
  function cadeauxAuPanier() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var t = {};
        (c.items || []).forEach(function (i) { if (i.properties && i.properties['_bf_cadeau']) t[i.properties['_bf_cadeau']] = true; });
        return t;
      })
      .catch(function () { return {}; });
  }

  /* On intercepte l'envoi du formulaire natif (phase de capture) : on ajoute d'abord
     le cadeau (sauf s'il y en a deja un), puis on relance l'envoi natif, qui ajoute
     la batterie et ouvre le tiroir. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (!f.querySelector('[data-add-to-cart]')) return;
    var idInput = f.querySelector('[name="id"]');
    if (!idInput || !table[idInput.value]) return; /* pas le formulaire du produit de la page */

    if (f.getAttribute('data-bf-passe') === '1') { f.removeAttribute('data-bf-passe'); return; }

    var gid = parseInt(idCadeau(), 10);
    var gid2 = parseInt(root.getAttribute('data-gift2') || '', 10);
    if (!gid && !gid2) return; /* aucun cadeau disponible : ajout normal de la batterie */

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = f.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.add('btn--loading');

    function relancer() {
      if (btn) btn.classList.remove('btn--loading');
      f.setAttribute('data-bf-passe', '1');
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    }

    cadeauxAuPanier().then(function (t) {
      /* 1 seul cadeau par commande : s'il y en a déjà un au panier, on n'en ajoute pas. */
      if (t['1'] || t.ct) return relancer();
      var items = gid2 ? [{ id: gid2, quantity: 1, properties: { '_bf_cadeau': 'ct' } }]
                       : [{ id: gid, quantity: 1, properties: { '_bf_cadeau': '1' } }];
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).catch(function () { /* cadeau indisponible : on ajoute quand meme la batterie */ })
        .then(relancer);
    });
  }, true);
})();
